import { PageHeader } from "@shared/components/PageHeader";
import { Badge } from "@shared/ui/badge";
import { Card, CardContent, CardHeader } from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";
import { useState } from "react";

export const RiskParameterTab: React.FC<{ data: any }> = ({ data }) => {
  const [selectedParameter, setSelectedParameter] = useState<string | null>(
    null
  );

  // ✅ Always make criticalityAssessment an array
  const riskParameters: any[] = Array.isArray(data?.criticalityAssessment)
    ? data.criticalityAssessment
    : [];

  const getScoreColor = (score: number) => {
    if (score >= 4) return "text-green-600";
    if (score >= 3) return "text-yellow-600";
    return "text-red-600";
  };

  return (
    <div>
      <Card>
        <CardHeader>
          <PageHeader
            title="System Critical Assessment Parameters"
            subtitle="Detailed breakdown of Critical assessment factors for this system"
          />
        </CardHeader>
        <CardContent className="mt-3">
          {riskParameters.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No risk parameters data available
            </div>
          ) : (
            <div className="space-y-4">
              {riskParameters.map((param: any, index: number) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors"
                  onClick={() =>
                    setSelectedParameter(
                      selectedParameter === param.name ? null : param.name
                    )
                  }
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-3">
                        <span className="font-medium">{param.name}</span>
                        <Badge variant="outline">{param.weight}% Weight</Badge>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="text-right">
                        <div
                          className={`text-lg font-semibold ${getScoreColor(
                            param.score
                          )}`}
                        >
                          {param.score}/5
                        </div>
                        <div className="text-xs text-gray-500">Score</div>
                      </div>
                      <Progress value={param.score * 20} className="w-20 h-2" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
